import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getPurchaseReadyItemsApi } from './getPurchaseReadyItems.api'
import getPurchaseReadyItemsInitialState from './getPurchaseReadyItems.initialState'
import { GetPurchaseReadyItemsErrorResponse, GetPurchaseReadyItemsRequestPayload } from './getPurchaseReadyItems.types'

export const getPurchaseReadyItems = createAsyncThunk(
  urls.admin.getPurchaseReadyItems,
  async (payload: GetPurchaseReadyItemsRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getPurchaseReadyItemsApi(request!)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getPurchaseReadyItemsSlice = createSlice({
  name: urls.admin.getPurchaseReadyItems,
  initialState: getPurchaseReadyItemsInitialState,
  reducers: {
    resetGetPurchaseReadyItems: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }

    // Add any additional reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseReadyItems.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getPurchaseReadyItems.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getPurchaseReadyItems.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetPurchaseReadyItemsErrorResponse
        state.success = null
      })
  }
})

export const { actions: getPurchaseReadyItemsActions, reducer: getPurchaseReadyItemsReducer } =
  getPurchaseReadyItemsSlice
export const { resetGetPurchaseReadyItems } = getPurchaseReadyItemsActions
export default getPurchaseReadyItemsSlice.reducer
